export const EURO_ZONE = [
  ["at", "austria", 1],
  ["be", "belgium", 2],
  ["bg", "bulgaria", 3],
  ["hr", "croatia", 4],
  ["cy", "cyprus", 5],
  ["cz", "czechia", 6],
  ["ee", "estonia", 8],
  ["fi", "finland", 9],
  ["fr", "france", 10],
  ["de", "germany", 11],
  ["gr", "greece", 12],
  ["hu", "hungary", 13],
  ["ie", "ireland", 14],
  ["it", "italy", 15],
  ["lv", "latvia", 16],
  ["lt", "lithuania", 17],
  ["lu", "luxembourg", 18],
  ["mt", "malta", 19],
  ["nl", "netherlands", 20],
  ["pt", "portugal", 22],
  ["ro", "romania", 23],
  ["sk", "slovakia", 24],
  ["si", "slovenia", 25],
  ["es", "spain", 26],
] as [string, string, number][];

export const JAPAN = [["jp", "japan", 100]] as [string, string, number][];

export const USA = [["us", "United States of America", 200]] as [string, string, number][];

export const Canada = [["ca", "canada", 300]] as [string, string, number][];

export const LATIN_AMERICA = [
  ["br", "brazil", 401],
  ["ar", "argentina", 402],
  ["mx", "mexico", 403],
  ["cl", "chile", 404],
  ["co", "colombia", 405],
  ["pe", "peru", 406],
  ["ve", "venezuela", 407],
  ["uy", "uruguay", 408],
  ["py", "paraguay", 409],
  ["bo", "bolivia", 410],
  ["ec", "ecuador", 411],
  ["do", "dominican rep.", 412],
  ["ht", "haiti", 413],
  ["cu", "cuba", 414],
  ["pa", "panama", 415],
  ["cr", "costa rica", 416],
  ["ni", "nicaragua", 417],
  ["hn", "honduras", 418],
  ["sv", "el salvador", 419],
  ["gt", "guatemala", 420],
  ["bz", "belize", 421],
  ["sr", "suriname", 422],
  ["gy", "guyana", 423],
] as [string, string, number][];

export const UnitedKingdom = [["gb", "united kingdom", 500]] as [string, string, number][];

export const EuropeExEuro = [
  ["is", "iceland", 601],
  ["no", "norway", 602],
  ["ch", "switzerland", 603],
  ["li", "liechtenstein", 604],
  ["se", "sweden", 605],
  ["dk", "denmark", 606],
  ["pl", "poland", 607],
] as [string, string, number][];

export const EmergingMarketsEurope = [
  ["ua", "ukraine", 701],
  ["md", "moldova", 704],
  ["al", "albania", 705],
  ["ba", "bosnia and herzegovina", 706],
  ["mk", "macedonia", 707],
  ["me", "montenegro", 708],
  ["rs", "serbia", 709],
  ["xk", "kosovo", 710],
  ["tr", "turkey", 711],
  ["ge", "georgia", 712],
  ["am", "armenia", 713],
  ["az", "azerbaijan", 714],
  ["kg", "kyrgyzstan", 715],
  ["uz", "uzbekistan", 716],
  ["tj", "tajikistan", 717],
] as [string, string, number][];

export const Africa = [
  ["eg", "egypt", 801],
  ["za", "south africa", 802],
  ["ng", "nigeria", 803],
  ["ke", "kenya", 804],
  ["gh", "ghana", 805],
  ["dz", "algeria", 806],
  ["ma", "morocco", 807],
  ["tn", "tunisia", 808],
  ["ne", "niger", 809],
  ["td", "chad", 810],
  ["sn", "senegal", 811],
  ["ml", "mali", 812],
  ["mr", "mauritania", 813],
  ["bf", "burkina faso", 814],
  ["ci", "côte d'ivoire", 815],
  ["lr", "liberia", 816],
  ["sl", "sierra leone", 817],
  ["cd", "central african rep.", 818],
  ["cg", "congo", 819],
  ["ug", "uganda", 820],
  ["sd", "sudan", 821],
  ["ly", "libya", 822],
  ["tn", "tunisia", 823],
  ["zw", "zimbabwe", 824],
  ["zm", "zambia", 825],
  ["bw", "botswana", 826],
  ["na", "namibia", 827],
  ["ao", "angola", 828],
  ["cm", "cameroon", 829],
  ["cf", "central african republic", 830],
  ["mg", "madagascar", 831],
  ["mz", "mozambique", 832],
  ["tz", "tanzania", 833],
  ["sx", "saint lucia", 834],
  ["so", "somalia", 835],
  ["et", "ethiopia", 836],
  ["ga", "gabon", 837],
  ["gn", "guinea", 838],
  ["gw", "guinea-bissau", 839],
  ["bj", "benin", 840],
  ["bg", "bulgaria", 841],
  ["sz", "swaziland", 842],
  ["mw", "malawi", 843],
  ["bi", "burundi", 844],
  ["er", "eritrea", 847],
  ["ss", "south sudan", 848],
  ["st", "sao tome and principe", 849],
  ["ls", "lesotho", 850],
  ["rw", "rwanda", 851],
  ["tg", "togo", 852],
  ["gq", "eq. guinea", 853],
] as [string, string, number][];

export const MiddleEast = [
  ["sa", "saudi arabia", 901],
  ["ae", "united arab emirates", 902],
  ["il", "israel", 903],
  ["ir", "iran", 904],
  ["qa", "qatar", 905],
  ["kw", "kuwait", 906],
  ["om", "oman", 907],
  ["bh", "bahrain", 908],
  ["ye", "yemen", 909],
] as [string, string, number][];

export const Australasia = [
  ["au", "australia", 1001],
  ["nz", "new zealand", 1002],
] as [string, string, number][];

export const DevelopedAsia = [
  ["jp", "japan", 1101],
  ["hk", "hong kong", 1102],
  ["sg", "singapore", 1103],
  ["kr", "south korea", 1104],
  ["tw", "taiwan", 1105],
] as [string, string, number][];

export const EmergingAsia = [
  ["cn", "china", 1201],
  ["in", "india", 1202],
  ["id", "indonesia", 1203],
  ["ph", "philippines", 1204],
  ["th", "thailand", 1205],
  ["vn", "vietnam", 1206],
  ["pk", "pakistan", 1207],
  ["bd", "bangladesh", 1208],
  ["lk", "sri lanka", 1209],
  ["ru", "russia", 1210],
  ["kz", "kazakhstan", 1211],
  ["mn", "mongolia", 1212],
  ["pg", "papua new guinea", 1213],
] as [string, string, number][];

export interface IRegion {
  type: string;
  name: string;
  countryCodes: [string, string, number][];
  value?: number;
  color?: string;
}

export const COLORS = [
  "#082f49",
  "#0c4a6e",
  "#075985",
  "#0369a1",
  "#0284c7",
  "#0ea5e9",
  "#38bdf8",
  "#7dd3fc",
  "#bae6fd",
  "#e0f2fe",
  "#f0f9ff",
  "#bfdbfe",
  "#dbeafe",
];

export const REGIONS: IRegion[] = [
  { type: "1", name: "USA", countryCodes: USA },
  { type: "2", name: "Canada", countryCodes: Canada },
  { type: "3", name: "Latin Amerika", countryCodes: LATIN_AMERICA },
  { type: "4", name: "Storbritania", countryCodes: UnitedKingdom },
  { type: "5", name: "Eurosonen", countryCodes: EURO_ZONE },
  { type: "6", name: "Europa - uten euro", countryCodes: EuropeExEuro },
  { type: "7", name: "Europa - Fremvoksende", countryCodes: EmergingMarketsEurope },
  { type: "8", name: "Afrika", countryCodes: Africa },
  { type: "9", name: "Midtøsten", countryCodes: MiddleEast },
  { type: "10", name: "Japan", countryCodes: JAPAN },
  { type: "11", name: "Australasia", countryCodes: Australasia },
  { type: "12", name: "Asia - Utviklet", countryCodes: DevelopedAsia },
  { type: "13", name: "Asia - Fremvoksende", countryCodes: EmergingAsia },
  // { type: "14", name: "Fremvoksende Markeder", countryCodes: [] },
  // { type: "15", name: "Utviklede Land", countryCodes: [] },
  // { type: "16", name: "Ikke klassifisert", countryCodes: [] },
];
